import { FaLinkedin, FaYoutube } from "react-icons/fa";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";

function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="container">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3>SPC Edge</h3>
            <p>
              Advanced Statistical Process Control software for manufacturing
              industries.
            </p>
            <div className="flex gap-6 mt-4 justify-center">
              <a
                href="https://www.linkedin.com/company/spcedge/"
                aria-label="LinkedIn"
                className="text-3xl hover:text-blue-500"
              >
                <FaLinkedin />
              </a>
              <a
                href="https://www.youtube.com/@SPC-Edge"
                aria-label="YouTube"
                className="text-3xl hover:text-red-500"
              >
                <FaYoutube />
              </a>
            </div>
          </div>

          <div>
            <h3>Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <HashLink to="/#features" className="text-gray-300 hover:text-white">
                  Features
                </HashLink>
              </li>
              <li>
                <HashLink
                  to="/#interfaces"
                  className="text-gray-300 hover:text-white"
                >
                  Interfaces
                </HashLink>
              </li>
              <li>
                <a
                  href="/roi-calculator"
                  className="text-gray-300 hover:text-white"
                >
                  Calculate ROI
                </a>
              </li>
              <li>
                <HashLink to="/#pricing" className="text-gray-300 hover:text-white">
                  Pricing
                </HashLink>
              </li>
              <li>
                <HashLink to="/#contact" className="text-gray-300 hover:text-white">
                  Contact
                </HashLink>
              </li>
            </ul>
          </div>

          <div>
            <h3>Resources</h3>
            <ul className="space-y-2">
              <li>
                <a href="#" className="text-gray-300 hover:text-white">
                  Documentation
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-300 hover:text-white">
                  Support
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-300 hover:text-white">
                  Blog
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-300 hover:text-white">
                  Case Studies
                </a>
              </li>
              <li>
                <Link to="/privacy-policy" className="text-gray-300 hover:text-white">
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400">
          <p>
            &copy; {new Date().getFullYear()} SPC Edge. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
